export default __webpack_public_path__ + "static/TheguardianofColoradosFrontRange-73ffc882ec25a8f465e204e5896d781c.jpg";